import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";

const otherData = [
  { value: 25, label: "Iceland (winter)", color: "rgba(0, 0, 0, 0.25)" },
  { value: 50, label: "Norway (winter)", color: "rgba(0, 0, 0, 0.25)" },
  { value: 70, label: "Alaska (winter)", color: "rgba(0, 0, 0, 0.25)" },
  { value: 75, label: "Netherlands (winter)", color: "rgba(0, 0, 0, 0.25)" },
  { value: 80, label: "Seattle (winter)", color: "rgba(0, 0, 0, 0.25)" },
  { value: 85, label: "Spain (winter)", color: "rgba(0, 0, 0, 0.25)" },
  { value: 90, label: "Denver (winter)", color: "rgba(0, 0, 0, 0.25)" },
  { value: 95, label: "Mexico City (winter)", color: "rgba(0, 0, 0, 0.25)" },
  { value: 100, label: "New Mexico (summer)", color: "rgba(0, 0, 0, 0.25)" },
];

export const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    y: {
      min: 0,
      max: 100,
      title: {
        display: true,
        text: "Boost Score",
      },
    },
    x: {
      ticks: { color: "grey" },
    },
  },
};

export default function ComparisonChart(props) {
  const [data, setData] = useState({
    datasets: [
      {
        data: otherData.map((item) => item.value),
      },
    ],
    labels: otherData.map((item) => item.label),
  });

  const { grade } = props;

  useEffect(() => {
    if (grade) {
      let copy = [...otherData];
      copy.push({
        label: "Your Location",
        value: grade,
        color: "#ED872D",
      });
      copy.sort((a, b) => a.value - b.value);
      setData({
        labels: copy.map((i) => i.label),
        datasets: [
          {
            data: copy.map((i) => i.value),
            backgroundColor: copy.map((i) => i.color),
          },
        ],
      });
    }
  }, [grade]);

  return (
    <div className="ComparisonChart">
      <h3>Greenhouse Comparison</h3>
      <div className="CompareExplain">
        The graph below compares greenhouses around the world for benefit from
        UbiGro. UbiGro performs best in sunny and clear locations.
      </div>
      <Bar data={data} options={options} />
    </div>
  );
}
